import { APP_NAME } from '@/config/appConfig'
import { getImage } from '@/config/sanityConfig'

const META_DATASET_PREFIX = 'lumenii-meta'

export default {
  computed: {
    metaMixin_loaded() {
      return this.metaTags.loaded
    }
  },

  watch: {
    metaMixin_loaded: {
      handler: function (loaded, _oldValue) {
        if (loaded) {
          document.title = this.metaTags.docTitle
          this.metaMixin_updateTags(this.metaTags.meta)
          /*
          this.metaMixin_createTags(this.metaTags.meta).forEach((tag) =>
            document.head.appendChild(tag)
          )
          */
        }
      }
    }
  },

  beforeDestroy: function () {
    document.title = APP_NAME
    this.metaMixin_removeTags()
  },

  methods: {
    metaMixin_createTags(meta) {
      return meta.map((metaTag) => {
        const tag = document.createElement('meta')

        Object.keys(metaTag).forEach((key) => {
          tag.setAttribute(key, metaTag[key])
        })

        tag.setAttribute(`data-${META_DATASET_PREFIX}`, '')

        return tag
      })
    },

    metaMixin_removeTags() {
      Array.from(document.querySelectorAll(`[data-${META_DATASET_PREFIX}]`)).map((el) =>
        el.parentNode.removeChild(el)
      )
    },

    metaMixin_updateTags(meta) {
      meta.forEach((metaTag) => {
        // { property: 'og:title', content: 'Lumenii' }
        const tagName =
          (metaTag.property && 'property') ||
          (metaTag.name && 'name') ||
          (metaTag.itemprop && 'itemprop')

        // update existing tag or create a new one
        document
          .querySelector(`meta[${tagName}~="${metaTag[tagName]}"]`)
          ?.setAttribute('content', metaTag.content)
      })
    },

    metaMixin_updateTag(tagName, tagValue) {
      document.querySelector(`meta[name="${tagName}"]`)?.setAttribute('content', tagValue)
    },

    metaMixin_getThumbnail(image) {
      return getImage(image).width(1200).height(630).url()
    }
  }
}
